import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=79b2112e&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=79b2112e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2112e",
  null
  
)

export default component.exports